module.exports = __webpack_public_path__ + "assets/d11c91d4f070ea31890f91b829f5ef94.jpg";